module.exports = __webpack_public_path__ + "img/37ne.05c8bb3d.svg";